export default __webpack_public_path__ + "assets/images/6513cb53d2825f3f7e619f636d719937.e47e92e6dd93b78ab0ffa2e2c6a9826b.png";